module.exports = __webpack_public_path__ + "img/productSearch_icon.3a2f813d.png";